export class StateExportConnectedRequest {
    requestUids: string[] = []
}